<template>
    <div class="headerFeedback" v-if="step == 'vergelijking' ">
      <div class="headerFeedback__group">
        <h2 class="headerFeedback__title">Vergelijk en kies jouw methode-mix</h2>
      </div>
      <div class="headerFeedback__actions">
        <router-link :to="{ name: 'tussenschermResultaat', params: {doelSlug: slug}}" class="button">Zet methodes (<span class="methodes_selection_count">{{ count }}</span>) in jouw resultaat</router-link>
        <!--<a class="button button--grey">Vergelijk methodes (<span class="methodes_selection_count">{{ count }}</span>)</a>-->
      </div>
    </div>

    <div class="headerFeedback" v-else-if="step == 'eindresultaat'">
      <div class="headerFeedback__group">
        <h2 class="headerFeedback__title">Jouw resultaat</h2>
      </div>
      <div class="headerFeedback__actions">
        <router-link :to="{ name: 'eindResultaatPDF', params: {doelSlug: slug} }" class="button">Maak mijn PDF</router-link>
      </div>
    </div>

    <div class="headerFeedback" v-else-if="step == 'pdf'">
      <div class="headerFeedback__group">
        <h2 class="headerFeedback__title">Methodes en tips voor {{ doel}}</h2>
      </div>
      <div class="headerFeedback__actions">
        <router-link :to="{ name: 'eindResultaatPDFDownload'}" class="button button--wide">Download als PDF</router-link>
        <!-- ToDo: Print knop / print CSS <router-link :to="{ name: 'versieHTML'}" class="button button--wide">Maak HTML</router-link> -->
      </div>
    </div>

    <div class="headerFeedback" v-else-if="step == 'html'">
      <div class="headerFeedback__group">
        <h2 class="headerFeedback__title">Methodes en tips voor {{ doel}}</h2>
      </div>
    </div>

    <div class="headerFeedback" v-else>
      <div class="headerFeedback__group">
        <h2 class="headerFeedback__title" v-if="count == 1">Er is {{ count }} methode voor jouw situatie</h2>
        <h2 class="headerFeedback__title" v-else>Er zijn {{ count }} methodes voor jouw situatie</h2>
        <p class="headerFeedback__subtext" v-html="tekst"></p>
      </div>
      <div class="headerFeedback__actions" v-if="selected > 0">
        <router-link :to="{ name: 'vergelijkMethodes', params: {doelSlug: slug, methods: methods}}" class="button">Vergelijk methodes (<span class="methodes_selection_count">{{ selected }}</span>)</router-link>
      </div>
    </div>

</template>


<script>
export default {
  name: "headerFeedback",

  data() {
    return {
      slug: '',
    }
  },
  
  props: {
    count: Number,
    selected: Number,
    step: String,
    doel: String,
    schermtitel: String,
    tekst: String,
    methods: Array
  },

  computed: {
  },

  methods: {
  },

  created() {
    this.slug = localStorage.getItem('slug')
    // show Path in main App div
  },

  mounted() {
    this.$emit('show',this.$route.path);
  }
};
</script>

